export default {"src":"/_next/static/media/checkmark-green.8290779a.svg","height":513,"width":512};